<template>
  <div class="article-main" @mouseover='mouseOver()' @mouseleave="mouseLeave()">
    <!-- <img v-for="(url,i) in urlList" :key="url" :src="url" alt="" :class="{active:(((value-1)%urlList.length)) == i, activeRight: (value%urlList.length)==i, banner:true}" @click="downFun((value%urlList.length)==i,url)" /> -->
    <el-image
      v-for="(url,i) in urlList" :key="url"
      :class="{active:(((value-1)%urlList.length)) == i, activeRight: (value%urlList.length)==i, banner:true}" @click="downFun((value%urlList.length)==i)"
      :src="url"
      :zoom-rate="1.2"
      :max-scale="7"
      :min-scale="0.2"
      :preview-src-list="(((value-1)%urlList.length)) == i? urlList:[]"
      :initial-index="4"
      fit="fill"
    />
    <!-- <div class="arrow-view" v-show="isActive">
      <div class="arrow-left" @click="toLeft()">左</div>
      <div class="arrow-right" @click="toRight()">右</div>
      <img src="../assets/arrow.png" class="arrow-left" @click="toLeft()" />
        <img src="../assets/arrow.png" class="arrow-right" @click="toRight()" />
    </div> -->
  </div>
</template>
<script>
export default {
  props:{
    urlList:Array,
  },
  data() {
    return {
      timer: '',
      isActive: false,
      value: 1,
    }
  },
  created() { },
  methods: {
    toLeft() {
      this.value--
      if (this.value == 0) {
        this.value = 3
      }
    },
    toRight() {
      this.value++
      if (this.value > 3) {
        this.value = 1
      }
    },
    downFun(flag){
      if (flag) {
        this.value++
        if (this.value > this.urlList.length) {
          this.value = 1
        }
      }
      
    },
    mouseOver() {
      if (this.urlList.length > 1) {
        this.isActive = true
        clearInterval(this.timer);
      }
      
    },
    mouseLeave() {
      if (this.urlList.length > 1) {
        this.isActive = false
        this.timer = setInterval(this.get, 3000);
      }
    },
    get() {
      this.value++;
      if (this.value > 3) {
        this.value = 1
      }
    }
  },
  mounted() {
    console.log(this.urlList.length);
    if (this.urlList.length > 1) {
      this.timer = setInterval(this.get, 3000);
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
}
</script>
<style scoped>
.arrow-left {
  position: absolute;
  left: 20px;
  top: 250px;
  cursor: pointer;
  transform: rotate(180deg);
}

.arrow-right {
  position: absolute;
  left: 280px;
  top: 250px;
  cursor: pointer;
}

.article-main {
  width: 100%;
  position: relative;
}

.banner {
  position: absolute;
  left: 30px;
  top: 20px;
  width: 338px;
  height: 286px;
  transition: all 1s;
  /* object-fit: cover; */
  cursor: pointer;
  background-color: #fff;
}

.active{
  top: 0px;
  left: 0px;
  z-index: 9999;
  border: 1px solid #000;
}
.activeRight{
  z-index: 999;
}

</style>
<style>
.article-main .el-image-viewer__img{
  width: auto !important;
  height: auto !important;
}
</style>